export const getAuthToken = () => {
  return localStorage.getItem('token');
};
